<template>
  <div class="full">
    <BGTemplate class="cg-layer cg-fixed-layer full" @ready="(v) => { engine = v; }">
    </BGTemplate>
    <BlueBubbles v-if="engine && engine.renderer && engine.scene && engine.camera" :camera="engine.camera" :amount="20" :renderer="engine.renderer" :scene="engine.scene"></BlueBubbles>

    <div class="cg-layer white-layer">
      <Toolbar></Toolbar>
      <h1>
        Analytics Page
      </h1>
      <div>
        <Activeness v-if="gameID" :gameTitle="title" :gameID="gameID"></Activeness>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  components: {
    Toolbar: () => import(/* webpackChunkName: "cloud" */ '../ui/Toolbar.vue'),
    BlueBubbles: () => import(/* webpackChunkName: "cloud" */ '../game/BlueBubbles.vue'),
    BGTemplate: () => import(/* webpackChunkName: "cloud" */ '../game/BGTemplate.vue'),
    Activeness: () => import('../../../_cloud/v0-buhk/ui/Activeness.vue')
  },
  computed: {
    gameID () {
      return this.$route.params.gameID
    },
    title () {
      return this.$route.params.title
    }
  },
  data () {
    return {
      engine: false
    }
  }
}
</script>

<style>

</style>
